/**
 * AUTO-GENERATED by `deno task gen:abi` — do not edit by hand.
 *
 * Source of truth: the Foundry build output in contracts/out/. Regenerate
 * after any change to the looper contracts. Hand-editing is how the loop()
 * signature drifted from the deployed contract; let the generator own it.
 */

export const LOOPER_MORPHO_ABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_morpho",
        "type": "address"
      },
      {
        "name": "_swapRouterAero",
        "type": "address"
      },
      {
        "name": "_cadc",
        "type": "address"
      },
      {
        "name": "_usdc",
        "type": "address"
      },
      {
        "name": "_market",
        "type": "tuple",
        "components": [
          {
            "name": "loanToken",
            "type": "address"
          },
          {
            "name": "collateralToken",
            "type": "address"
          },
          {
            "name": "oracle",
            "type": "address"
          },
          {
            "name": "irm",
            "type": "address"
          },
          {
            "name": "lltv",
            "type": "uint256"
          }
        ]
      },
      {
        "name": "_owner",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "CADC",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "DEFAULT_ORACLE_DIVERGENCE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MARKET_ID",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "bytes32"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MARKET_IRM",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MARKET_LLTV",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MARKET_ORACLE",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_ITERATIVE_LEVERAGE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_LEVERAGE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_ORACLE_DIVERGENCE_CEILING_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_SLIPPAGE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MIN_LEVERAGE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MORPHO",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "STEP_FACTOR_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "USDC",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "acceptOwnership",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "feeConfig",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "loop",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "slippageBps",
        "type": "uint16"
      },
      {
        "name": "minLeverageBps",
        "type": "uint32"
      }
    ],
    "outputs": [
      {
        "name": "finalCollateral",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "loopIterative",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "slippageBps",
        "type": "uint16"
      },
      {
        "name": "minLeverageBps",
        "type": "uint32"
      }
    ],
    "outputs": [
      {
        "name": "finalCollateral",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "market",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "tuple",
        "components": [
          {
            "name": "loanToken",
            "type": "address"
          },
          {
            "name": "collateralToken",
            "type": "address"
          },
          {
            "name": "oracle",
            "type": "address"
          },
          {
            "name": "irm",
            "type": "address"
          },
          {
            "name": "lltv",
            "type": "uint256"
          }
        ]
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "onMorphoFlashLoan",
    "inputs": [
      {
        "name": "assets",
        "type": "uint256"
      },
      {
        "name": "data",
        "type": "bytes"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "oracleDivergenceBps",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "owner",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "pendingOwner",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "previewLoop",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      }
    ],
    "outputs": [
      {
        "name": "viable",
        "type": "bool"
      },
      {
        "name": "flashUsdc",
        "type": "uint256"
      },
      {
        "name": "availableLiquidity",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "previewLoopIterative",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      }
    ],
    "outputs": [
      {
        "name": "viable",
        "type": "bool"
      },
      {
        "name": "iterations",
        "type": "uint8"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "renounceOwnership",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setFeeConfig",
    "inputs": [
      {
        "name": "newFee",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOracleDivergenceBps",
    "inputs": [
      {
        "name": "newBps",
        "type": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setSwapRouterAero",
    "inputs": [
      {
        "name": "newRouter",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "swapRouterAero",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "transferOwnership",
    "inputs": [
      {
        "name": "newOwner",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "unwind",
    "inputs": [
      {
        "name": "maxRepay",
        "type": "uint256"
      },
      {
        "name": "collateralToPull",
        "type": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "returned",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "unwindBySwap",
    "inputs": [
      {
        "name": "collateralToSwap",
        "type": "uint256"
      },
      {
        "name": "collateralToReturn",
        "type": "uint256"
      },
      {
        "name": "slippageBps",
        "type": "uint16"
      },
      {
        "name": "repaySharesPart",
        "type": "uint256"
      },
      {
        "name": "maxDivergenceBps",
        "type": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "cadcReturned",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "FeeConfigUpdated",
    "inputs": [
      {
        "name": "oldFee",
        "type": "address",
        "indexed": false
      },
      {
        "name": "newFee",
        "type": "address",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "LoopOpened",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "indexed": true
      },
      {
        "name": "principal",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "leverageBps",
        "type": "uint32",
        "indexed": false
      },
      {
        "name": "borrowRounds",
        "type": "uint8",
        "indexed": false
      },
      {
        "name": "finalCollateral",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "totalBorrowed",
        "type": "uint256",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "LoopUnwound",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "indexed": true
      },
      {
        "name": "collateralReturned",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "usdcRepaid",
        "type": "uint256",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OracleDivergenceUpdated",
    "inputs": [
      {
        "name": "oldBps",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "newBps",
        "type": "uint256",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipTransferStarted",
    "inputs": [
      {
        "name": "previousOwner",
        "type": "address",
        "indexed": true
      },
      {
        "name": "newOwner",
        "type": "address",
        "indexed": true
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipTransferred",
    "inputs": [
      {
        "name": "previousOwner",
        "type": "address",
        "indexed": true
      },
      {
        "name": "newOwner",
        "type": "address",
        "indexed": true
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SwapRouterUpdated",
    "inputs": [
      {
        "name": "oldRouter",
        "type": "address",
        "indexed": false
      },
      {
        "name": "newRouter",
        "type": "address",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "CollateralExceedsPosition",
    "inputs": [
      {
        "name": "requested",
        "type": "uint256"
      },
      {
        "name": "available",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "DivergenceOutOfRange",
    "inputs": [
      {
        "name": "requestedBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "FeesNotZero",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InsufficientSwapOutput",
    "inputs": [
      {
        "name": "received",
        "type": "uint256"
      },
      {
        "name": "required",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "InvalidLltv",
    "inputs": [
      {
        "name": "lltv",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "LeverageOutOfRange",
    "inputs": [
      {
        "name": "leverageBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "LeverageUnreachable",
    "inputs": [
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "stepFactorBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "MarketTokenMismatch",
    "inputs": []
  },
  {
    "type": "error",
    "name": "MinLeverageOutOfRange",
    "inputs": [
      {
        "name": "minLeverageBps",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "OracleZeroPrice",
    "inputs": []
  },
  {
    "type": "error",
    "name": "OwnableInvalidOwner",
    "inputs": [
      {
        "name": "owner",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "OwnableUnauthorizedAccount",
    "inputs": [
      {
        "name": "account",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "RealisedLeverageBelowFloor",
    "inputs": [
      {
        "name": "realisedBps",
        "type": "uint256"
      },
      {
        "name": "floorBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "ReentrancyGuardReentrantCall",
    "inputs": []
  },
  {
    "type": "error",
    "name": "RepayExceedsDebt",
    "inputs": [
      {
        "name": "requested",
        "type": "uint256"
      },
      {
        "name": "owedShares",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "SafeERC20FailedOperation",
    "inputs": [
      {
        "name": "token",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "SlippageOutOfRange",
    "inputs": [
      {
        "name": "slippageBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "UnauthorizedCallback",
    "inputs": [
      {
        "name": "sender",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "UnknownFlashOp",
    "inputs": [
      {
        "name": "op",
        "type": "uint8"
      }
    ]
  },
  {
    "type": "error",
    "name": "VenueZeroAddress",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ZeroAmount",
    "inputs": []
  }
] as const;

export const LOOPER_AJNA_ABI = [
  {
    "type": "constructor",
    "inputs": [
      {
        "name": "_factory",
        "type": "address"
      },
      {
        "name": "_morpho",
        "type": "address"
      },
      {
        "name": "_ajnaPool",
        "type": "address"
      },
      {
        "name": "_swapRouterAero",
        "type": "address"
      },
      {
        "name": "_cadc",
        "type": "address"
      },
      {
        "name": "_usdc",
        "type": "address"
      },
      {
        "name": "_owner",
        "type": "address"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "CADC",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "DEFAULT_ORACLE_DIVERGENCE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "FACTORY",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_ORACLE_DIVERGENCE_CEILING_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MAX_SLIPPAGE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MIN_LEVERAGE_BPS",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "MORPHO",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "USDC",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "acceptOwnership",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "ajnaPool",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "feeConfig",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "loop",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "stepFactorBps",
        "type": "uint16"
      },
      {
        "name": "slippageBps",
        "type": "uint16"
      },
      {
        "name": "minLeverageBps",
        "type": "uint32"
      },
      {
        "name": "limitIndex",
        "type": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "finalCollateral",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "loopIterative",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "stepFactorBps",
        "type": "uint16"
      },
      {
        "name": "slippageBps",
        "type": "uint16"
      },
      {
        "name": "minLeverageBps",
        "type": "uint32"
      },
      {
        "name": "limitIndex",
        "type": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "finalCollateral",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "onMorphoFlashLoan",
    "inputs": [
      {
        "name": "assets",
        "type": "uint256"
      },
      {
        "name": "data",
        "type": "bytes"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "oracleDivergenceBps",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "owner",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "pendingOwner",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "positionOf",
    "inputs": [
      {
        "name": "user",
        "type": "address"
      }
    ],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "previewLoop",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "stepFactorBps",
        "type": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "viable",
        "type": "bool"
      },
      {
        "name": "flashUsdc",
        "type": "uint256"
      },
      {
        "name": "availableLiquidity",
        "type": "uint256"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "previewLoopIterative",
    "inputs": [
      {
        "name": "principal",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "stepFactorBps",
        "type": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "viable",
        "type": "bool"
      },
      {
        "name": "iterations",
        "type": "uint8"
      }
    ],
    "stateMutability": "pure"
  },
  {
    "type": "function",
    "name": "renounceOwnership",
    "inputs": [],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setAjnaPool",
    "inputs": [
      {
        "name": "newPool",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setFeeConfig",
    "inputs": [
      {
        "name": "newFee",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setOracleDivergenceBps",
    "inputs": [
      {
        "name": "newBps",
        "type": "uint256"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "setSwapRouterAero",
    "inputs": [
      {
        "name": "newRouter",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "swapRouterAero",
    "inputs": [],
    "outputs": [
      {
        "name": "",
        "type": "address"
      }
    ],
    "stateMutability": "view"
  },
  {
    "type": "function",
    "name": "transferOwnership",
    "inputs": [
      {
        "name": "newOwner",
        "type": "address"
      }
    ],
    "outputs": [],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "unwind",
    "inputs": [
      {
        "name": "maxRepayNative",
        "type": "uint256"
      },
      {
        "name": "collateralToPull",
        "type": "uint256"
      },
      {
        "name": "limitIndex",
        "type": "uint256"
      }
    ],
    "outputs": [
      {
        "name": "returned",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "function",
    "name": "unwindBySwap",
    "inputs": [
      {
        "name": "maxRepayNative",
        "type": "uint256"
      },
      {
        "name": "collateralToSwap",
        "type": "uint256"
      },
      {
        "name": "collateralToReturn",
        "type": "uint256"
      },
      {
        "name": "slippageBps",
        "type": "uint16"
      },
      {
        "name": "limitIndex",
        "type": "uint256"
      },
      {
        "name": "maxDivergenceBps",
        "type": "uint16"
      }
    ],
    "outputs": [
      {
        "name": "cadcReturned",
        "type": "uint256"
      }
    ],
    "stateMutability": "nonpayable"
  },
  {
    "type": "event",
    "name": "AjnaPoolUpdated",
    "inputs": [
      {
        "name": "oldPool",
        "type": "address",
        "indexed": false
      },
      {
        "name": "newPool",
        "type": "address",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "FeeConfigUpdated",
    "inputs": [
      {
        "name": "oldFee",
        "type": "address",
        "indexed": false
      },
      {
        "name": "newFee",
        "type": "address",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "LoopOpened",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "indexed": true
      },
      {
        "name": "principal",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "leverageBps",
        "type": "uint32",
        "indexed": false
      },
      {
        "name": "borrowRounds",
        "type": "uint8",
        "indexed": false
      },
      {
        "name": "finalCollateral",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "totalBorrowed",
        "type": "uint256",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "LoopUnwound",
    "inputs": [
      {
        "name": "user",
        "type": "address",
        "indexed": true
      },
      {
        "name": "collateralReturned",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "usdcRepaid",
        "type": "uint256",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OracleDivergenceUpdated",
    "inputs": [
      {
        "name": "oldBps",
        "type": "uint256",
        "indexed": false
      },
      {
        "name": "newBps",
        "type": "uint256",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipTransferStarted",
    "inputs": [
      {
        "name": "previousOwner",
        "type": "address",
        "indexed": true
      },
      {
        "name": "newOwner",
        "type": "address",
        "indexed": true
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "OwnershipTransferred",
    "inputs": [
      {
        "name": "previousOwner",
        "type": "address",
        "indexed": true
      },
      {
        "name": "newOwner",
        "type": "address",
        "indexed": true
      }
    ],
    "anonymous": false
  },
  {
    "type": "event",
    "name": "SwapRouterUpdated",
    "inputs": [
      {
        "name": "oldRouter",
        "type": "address",
        "indexed": false
      },
      {
        "name": "newRouter",
        "type": "address",
        "indexed": false
      }
    ],
    "anonymous": false
  },
  {
    "type": "error",
    "name": "DivergenceOutOfRange",
    "inputs": [
      {
        "name": "requestedBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "FeesNotZero",
    "inputs": []
  },
  {
    "type": "error",
    "name": "InsufficientSwapOutput",
    "inputs": [
      {
        "name": "received",
        "type": "uint256"
      },
      {
        "name": "required",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "LeverageOutOfRange",
    "inputs": [
      {
        "name": "leverageBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "LeverageUnreachable",
    "inputs": [
      {
        "name": "leverageBps",
        "type": "uint32"
      },
      {
        "name": "stepFactorBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "MinLeverageOutOfRange",
    "inputs": [
      {
        "name": "minLeverageBps",
        "type": "uint256"
      },
      {
        "name": "leverageBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "OwnableInvalidOwner",
    "inputs": [
      {
        "name": "owner",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "OwnableUnauthorizedAccount",
    "inputs": [
      {
        "name": "account",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "RealisedLeverageBelowFloor",
    "inputs": [
      {
        "name": "realisedBps",
        "type": "uint256"
      },
      {
        "name": "floorBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "ReentrancyGuardReentrantCall",
    "inputs": []
  },
  {
    "type": "error",
    "name": "SafeERC20FailedOperation",
    "inputs": [
      {
        "name": "token",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "SlippageOutOfRange",
    "inputs": [
      {
        "name": "slippageBps",
        "type": "uint256"
      }
    ]
  },
  {
    "type": "error",
    "name": "UnauthorizedCallback",
    "inputs": [
      {
        "name": "sender",
        "type": "address"
      }
    ]
  },
  {
    "type": "error",
    "name": "UnknownFlashOp",
    "inputs": [
      {
        "name": "op",
        "type": "uint8"
      }
    ]
  },
  {
    "type": "error",
    "name": "VenueZeroAddress",
    "inputs": []
  },
  {
    "type": "error",
    "name": "ZeroAmount",
    "inputs": []
  }
] as const;

/**
 * Legacy alias for callers that only touch the shared surface (loop, unwind,
 * the view getters, the events). These signatures are identical across both
 * loopers, so aliasing the Morpho ABI is safe.
 */
export const LOOPER_ABI = LOOPER_MORPHO_ABI;
